import React, {FC} from 'react';
import {Routes} from 'constants/index';
import {Link} from 'gatsby';
import {usePermissions} from 'hooks/usePermissions';
import {Configs} from 'templates/reports/types';

import * as styles from './styles.module.scss';

type HeaderProps = Configs['header'] & {
	handle?: string
	sample?: boolean
}

const Header: FC<HeaderProps> = (props) => {
	const {auth} = usePermissions();
	const name = () => {
		if (props.sample) {
			return 'Sample User';
		} else if (props.handle) {
			return props.handle;
		}

		// Generally use the handle if present;
		// but only available on reports after
		// ~12/20/24. Use user's name if absent.
		if (auth.user?.name) {
			return auth.user?.name;
		}

		// Fallback if we have nothing better
		return 'Sample User';
	};

	return (
		<div className={styles.wrapper}>
			<span className={styles.title}>
				Hi, {name()}!
			</span>
			<div className={styles.text}>
				<span>
					<strong>Your DEXA report is ready.</strong> This
					report was generated on {props.generated} and
					compares data from {props.count} of your scans
					against {props.reference}. You
					can customize your selected scans and reference
					population when generating your report.
				</span>
				{!props.sample && auth.isLoggedIn && (
					<Link to={Routes.reports}>
						Looking for your old reports? Click here {'>'}
					</Link>
				)}
			</div>
		</div>
	);
};

export default Header;
